// @flow
import React, { Component, type ComponentType } from "react";

type Props = {|
    BlogCard: ComponentType<any>,
    Dialog: ComponentType<any>,
    blog: ComponentType<any>,
    onHideBlog: Function
|};

class BlogDialog extends Component<Props> {
    handleClose = () => {
        this.props.onHideBlog();
    };

    render() {
        const { blog, Dialog, BlogCard } = this.props;

        return (
            <Dialog open={blog !== null} onHide={this.handleClose}>
                {blog !== null && <BlogCard fullDetail key={blog.id} blog={blog} />}
            </Dialog>
        );
    }
}

export default BlogDialog;



// WEBPACK FOOTER //
// ./src/blog-dialog/view.js